import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const Hero = ({ title, items, className }) => {
  if (!items.length) return null;

  return (
    <>
      <h2
        className={clsx(
          'text-center text-lg font-medium leading-snug tracking-tight text-new-gray-1 lg:text-[14px]',
          className
        )}
      >
        {title}
      </h2>

      <ul className="mt-12 flex justify-between xl:mt-7 md:flex-wrap md:justify-center lg:gap-y-5 lg:gap-x-7 md:gap-x-6 md:gap-y-3">
        {items.map(({ src, width, height }, index) => (
          <li key={index}>
            <img
              className="h-10 xl:h-9 lg:h-7 w-auto"
              src={src}
              width={width}
              height={height}
              loading="eager"
              alt=""
            />
          </li>
        ))}
      </ul>
    </>
  );
};

Hero.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
};

Hero.defaultProps = {
  className: '',
};

export default Hero;
